
export enum PartyType {
        complainant = 'reqParty' ,
        respondent = 'respParty'
    }

    export enum PartyInfoType {
        Claimant = 'reqParty' ,
        respondent = 'respParty',
        ClaimantRepBy = 'reqPartyRepBy' ,
        respondentRepBy = 'respPartyRepBy'
    }

    export enum PrivateType {
        INDAUTOR = 'indautor' ,
        DNDA = 'dnda'
    } 

    
export class Party {
    id?: number;
    name?: string;
    address?: string;
    stateOrCounty?:string;
    telephone?: string;
    email?: string;
    countryCode?: string;
    country?: string;
    type?: PartyType;
    representedBy?: string;
    addressRepresentative?: string;
    telephoneRepresentative?: string;
    emailRepresentative?: string;
    typeOfParty?: string;
    typeOfPartyOther?:string;
    gender?: string;
}

export class partyInformation {
id?: number;
  nameClaimant?: string;
  addressClaimant?: string;
  stateOrCountyClaimant?: string;
  countryClaimantCode?: string;
  telephoneClaimant?: string;
  emailClaimant?: string;
  typeClaimant?: string;
  managerComplainant?: string;
  genderClaimant?: string;

  nameClaimantRepBy?: string;
  addressClaimantRepBy?: string;
  stateOrCountyClaimantRepBy?: string;
  countryClaimantRepByCode?: string;
  telephoneClaimantRepBy?: string;
  emailClaimantRepBy?: string;
  typeClaimantRepBy?: string;
  genderClaimantRepBy?: string;

  nameRespondent?: string;
  addressRespondent?: string;
  stateOrCountyRespondent?: string;
  countryRespondentCode?: string;
  telephoneRespondent?: string;
  emailRespondent?: string;
  typeRespondent?: string;
  genderRespondent?: string;

  nameRespondentRepBy?: string;
  addressRespondentRepBy?: string;
  stateOrCountyRespondentRepBy?: string;
  countryRespondantRepByCode?: string;
  telephoneRespondentRepBy?: string;
  emailRespondentRepBy?: string;
  typeRespondentRepBy?: string;
  genderRespondentRepBy?: string;


}



export class Claimant {
  id?: number;
  nameClaimant?: string;
  addressClaimant?: string;
  stateOrCountyClaimant?: string;
  countryClaimantCode?: string;
  telephoneClaimant?: string;
  emailClaimant?: string;
  typeClaimant?: string;
  managerComplainant?: string;
  typeClaimantOther?:string;
  genderClaimant?: string;
  identificationNumberClaimant?: string;
  prefixComplainant?: string;

  // Additional party fields
  typeOfParty?: string;
  typeOfPartyOther?: string;
  gender?: string;


}

export class ClaimantRepBy {
  id?: number;
  nameClaimantRepBy?: string;
  addressClaimantRepBy?: string;
  stateOrCountyClaimantRepBy?: string;
  countryClaimantRepByCode?: string;
  telephoneClaimantRepBy?: string;
  emailClaimantRepBy?: string;
  typeClaimantRepBy?: string;
  genderClaimantRepBy?: string;
}

export class Respondent {
  id?: number;  
  nameRespondent?: string;
  addressRespondent?: string;
  stateOrCountyRespondent?: string;
  countryRespondantCode?: string;
  telephoneRespondent?: string;
  emailRespondent?: string;
  typeRespondent?: string;
  managerRespondent?: string;
  typeRespondentOther?: string;
  genderRespondent?: string;
  identificationNumberRespondent?: string;
  prefixRespondent?: string;

  // Additional party fields
  typeOfParty?: string;
  typeOfPartyOther?: string;
  gender?: string;
}

export class RespondentRepBy {
  id?: number;  
  nameRespondentRepBy?: string;
  addressRespondentRepBy?: string;
  stateOrCountyRespondentRepBy?: string;
  countryRespondantRepByCode?: string;
  telephoneRespondentRepBy?: string;
  emailRespondentRepBy?: string;
  typeRespondentRepBy?: string;
  genderRespondentRepBy?: string;
}

